<div class="loader" [ngClass]="size">
    <ng-lottie #loading [options]="{ path: this.lottiePath }"></ng-lottie>
</div>
